import invitationRouterPaths from './invitationRouterPaths';

export default invitationRouterPaths;
